import { LegalForm } from 'apis/legitimizer/types';

type LegalFormOption = { value: LegalForm; translationKey: string };

export const legalFormConfig: Record<string, LegalFormOption> = {
  publicLimitedCompany: {
    value: 'PUBLIC_LIMITED_COMPANY',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.public-limited-company',
  },
  privateLimitedCompany: {
    value: 'PRIVATE_LIMITED_COMPANY',
    translationKey:
      'compliance.kyb.sections.basic-info.business-information.legal-form-options.private-limited-company',
  },
  partnership: {
    value: 'PARTNERSHIP',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.partnership',
  },
  soleTrader: {
    value: 'SOLE_TRADER',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.sole-trader',
  },
  publicAuthority: {
    value: 'PUBLIC_AUTHORITY',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.public-authority',
  },
  nonProfitOrganisation: {
    value: 'NON_PROFIT_ORGANISATION',
    translationKey:
      'compliance.kyb.sections.basic-info.business-information.legal-form-options.non-profit-organisation',
  },
  branch: {
    value: 'BRANCH',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.branch',
  },
  foreignCompany: {
    value: 'FOREIGN_COMPANY',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.foreign-company',
  },
  other: {
    value: 'OTHER',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.legal-form-options.legal-form-other',
  },
};

export const legalFormOptions = Object.values(legalFormConfig);

type FieldOfIndustryOption = { value: string; translationKey: string };

export const fieldOfIndustryOptions: FieldOfIndustryOption[] = [
  {
    value: 'restaurant',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.field-of-industry-options.restaurant',
  },
  {
    value: 'retail',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.field-of-industry-options.retail',
  },
  {
    value: 'other',
    translationKey: 'compliance.kyb.sections.basic-info.business-information.field-of-industry-options.other-option',
  },
];
